import React from 'react';

const TypingDots = () => {
  return (
    <div className="flex items-center gap-1.5 mt-1">
      <span className="w-2 h-2 bg-stone-500 rounded-full animate-bounce" style={{ animationDelay: '-0.3s' }} />
      <span className="w-2 h-2 bg-stone-500 rounded-full animate-bounce" style={{ animationDelay: '-0.15s' }} />
      <span className="w-2 h-2 bg-stone-500 rounded-full animate-bounce" />
    </div>
  );
};

export default TypingDots;
